import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { getStaffTimeConfigurationReport } from "../../api/attendanceReportApi";
import "./Attendance.css";

/**
 * Direct port of digicampusbd's `staff-attendance-time-configuration-report`
 * ("Time Config Report") — one row per active staff, their whole configured
 * weekly schedule (no actual attendance data at all). Confirmed via
 * `AttendanceTimeConfigurationService.staffAttendanceTimeConfigReport` this
 * is a pure pivot of `StaffAttendanceTimeConfiguration` rows, no filters at
 * all — new `GET /api/attendance/reports/staff/time-configuration-report`.
 */
export default function StaffTimeConfigReportPage() {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    getStaffTimeConfigurationReport()
      .then(setRows)
      .catch(() => setError("Failed to load time configuration report."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Staff Attendance — Time Config Report</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : (
        rows && (
          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Staff Name</th>
                  <th>Designation</th>
                  <th>Saturday</th>
                  <th>Sunday</th>
                  <th>Monday</th>
                  <th>Tuesday</th>
                  <th>Wednesday</th>
                  <th>Thursday</th>
                  <th>Friday</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.staffId}>
                    <td>{r.staffName}</td>
                    <td>{r.designation}</td>
                    <td>{r.saturdayTime || "-"}</td>
                    <td>{r.sundayTime || "-"}</td>
                    <td>{r.mondayTime || "-"}</td>
                    <td>{r.tuesdayTime || "-"}</td>
                    <td>{r.wednesdayTime || "-"}</td>
                    <td>{r.thursdayTime || "-"}</td>
                    <td>{r.fridayTime || "-"}</td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={9}>No staff time configuration found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )
      )}
    </MainLayout>
  );
}
